const ImageProc = {};

ImageProc.draw = (srcCanvas, dstCanvas, point) => {
  const srcCtx = srcCanvas.getContext("2d");
  const dstCtx = dstCanvas.getContext("2d");
  const srcW = srcCanvas.width;
  const srcH = srcCanvas.height;
  const dstW = dstCanvas.width;
  const dstH = dstCanvas.height;

  let input = srcCtx.getImageData(0, 0, srcW, srcH);
  let output = dstCtx.getImageData(0, 0, dstW, dstH);

  for (let i = 0; i < srcH; ++i) {
    for (let j = 0; j < srcW; ++j) {
      const inPixel = ImageProc.getPixel(input, j, i);
      if (inPixel.A === 0) {
        continue;
      }
      const outPixel = ImageProc.getPixel(output, point.x + j, point.y + i);
      let r = 255 - (255 - outPixel.R) * (255 / inPixel.R);
      r = r < 0 ? 0 : r;
      let g = 255 - (255 - outPixel.G) * (255 / inPixel.G);
      g = g < 0 ? 0 : g;
      let b = 255 - (255 - outPixel.B) * (255 / inPixel.B);
      b = b < 0 ? 0 : b;
      let a = 255 - (255 - outPixel.A) * (255 / inPixel.A);
      a = a < 0 ? 0 : a;
      const outIndex = ImageProc.positionToIndex(
        point.x + j,
        point.y + i,
        dstW
      );
      output.data[outIndex] = r;
      output.data[outIndex + 1] = g;
      output.data[outIndex + 2] = b;
    }
  }

  dstCtx.putImageData(output, 0, 0);
};

ImageProc.positionToIndex = (x, y, width) => {
  return width * y * 4 + x * 4;
};

ImageProc.getPixel = (imageData, x, y) => {
  var pixels = imageData.data;
  var index = imageData.width * y * 4 + x * 4;
  if (index < 0 || index + 3 > pixels.length) return undefined;
  return {
    R: pixels[index + 0],
    G: pixels[index + 1],
    B: pixels[index + 2],
    A: pixels[index + 3],
  };
};

const getGrayscaleParam = (r, g, b) => 0.2126 * r + 0.7152 * g + 0.0722 * b;

/**
 * グレースケール化実行
 * @param {*} srcCanvasContext 2値化対象のCanvasContext
 * @param {*} dstCanvasContext 処理結果を出力するCanvasContext
 * @param {*} width 画像の幅
 * @param {*} height 画像の高さ
 */
ImageProc.grayscale = (srcCanvasContext, dstCanvasContext, width, height) => {
  const src = srcCanvasContext.getImageData(0, 0, width, height);
  const dst = dstCanvasContext.createImageData(width, height);

  for (let i = 0; i < dst.data.length; i += 4) {
    const v = getGrayscaleParam(src.data[i], src.data[i + 1], src.data[i + 2]);
    dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = v;
    dst.data[i + 3] = 255;
  }
  dstCanvasContext.putImageData(dst, 0, 0);
};

/**
 * 2値化のパラメータを画素データから算出
 * @param {*} src 画素データ
 * @returns 2値化パラメータ
 */
ImageProc.getThresholdParam = (src) => {
  let histgram = Array(256).fill(0);
  let t = 0;
  let max = 0;

  for (let i = 0; i < src.data.length; i += 4) {
    let g = ~~getGrayscaleParam(src.data[i], src.data[i + 1], src.data[i + 2]);
    histgram[g]++;
  }

  for (let i = 0; i < 256; i++) {
    let w1 = 0;
    let w2 = 0;
    let sum1 = 0;
    let sum2 = 0;
    let m1 = 0;
    let m2 = 0;
    for (let j = 0; j <= i; ++j) {
      w1 += histgram[j];
      sum1 += j * histgram[j];
    }
    for (let j = i + 1; j < 256; ++j) {
      w2 += histgram[j];
      sum2 += j * histgram[j];
    }
    if (w1) {
      m1 = sum1 / w1;
    }
    if (w2) {
      m2 = sum2 / w2;
    }
    let tmp = w1 * w2 * (m1 - m2) * (m1 - m2);
    if (tmp > max) {
      max = tmp;
      t = i;
    }
  }
  return t;
};

/**
 * 2値化実行
 * @param {*} srcCanvasContext 2値化対象のCanvasContext
 * @param {*} dstCanvasContext 処理結果を出力するCanvasContext
 * @param {*} width 画像の幅
 * @param {*} height 画像の高さ
 */
ImageProc.threshold = (srcCanvasContext, dstCanvasContext, width, height) => {
  const src = srcCanvasContext.getImageData(0, 0, width, height);
  const dst = dstCanvasContext.createImageData(width, height);

  const t = ImageProc.getThresholdParam(src);

  for (let i = 0; i < dst.data.length; i += 4) {
    const v = getGrayscaleParam(src.data[i], src.data[i + 1], src.data[i + 2]);
    if (src.data[i + 3] < 0) {
      dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = 0;
      dst.data[i + 3] = 0;
    } else if (v < t) {
      dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = 0;
      dst.data[i + 3] = 0;
    } else {
      dst.data[i] = 166;
      dst.data[i + 1] = 120;
      dst.data[i + 2] = 42;
      dst.data[i + 3] = 255;
    }
  }

  //4隅が色付きだったらすべての画素データを反転
  if (
    ImageProc.getPixel(dst, 0, 0).R > 0 ||
    ImageProc.getPixel(dst, width - 1, 0).R > 0 ||
    ImageProc.getPixel(dst, 0, height - 1).R > 0 ||
    ImageProc.getPixel(dst, width - 1, height - 1).R > 0
  ) {
    for (let i = 0; i < dst.data.length; i += 4) {
      if (dst.data[i] > 0) {
        dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = 0;
        dst.data[i + 3] = 0;
      } else {
        dst.data[i] = 166;
        dst.data[i + 1] = 120;
        dst.data[i + 2] = 42;
        dst.data[i + 3] = 255;
      }
    }
  }
  dstCanvasContext.putImageData(dst, 0, 0);
};

ImageProc.multi = (
  src1CanvasContext,
  src2CanvasContext,
  dstCanvasContext,
  width,
  height
) => {
  const src1 = src1CanvasContext.getImageData(0, 0, width, height);
  const src2 = src2CanvasContext.getImageData(0, 0, width, height);
  const dst = dstCanvasContext.createImageData(width, height);

  for (let i = 0; i < dst.data.length; i += 4) {
    for (let j = 0; j < 3; j++) {
      dst.data[i + j] = (src1.data[i + j] * src2.data[i + j]) / 255;
    }
    dst.data[i + 3] = 255;
  }
};

ImageProc.grayAndMulti = (
  src1CanvasContext,
  src2CanvasContext,
  dstCanvasContext,
  width,
  height
) => {
  const src1 = src1CanvasContext.getImageData(0, 0, width, height);
  const src2 = src2CanvasContext.getImageData(0, 0, width, height);
  const dst = dstCanvasContext.createImageData(width, height);

  for (let i = 0; i < dst.data.length; i += 4) {
    const v = getGrayscaleParam(
      src1.data[i],
      src1.data[i + 1],
      src1.data[i + 2]
    );
    for (let j = 0; j < 3; j++) {
      dst.data[i + j] = (v * src2.data[i + j]) / 255;
    }
    dst.data[i + 3] = 255;
  }
  dstCanvasContext.putImageData(dst, 0, 0);
};

export default ImageProc;
